import { UUID } from "@/shared/types/entity-id";
import { Assessment } from "./assessment";

export type Photo = Assessment & {
  comment: string;
  fileId: string | null;
  conductedAt: string;
};

export function newPhoto(id: UUID, ahuId: UUID, componentId: UUID): Photo {
  return {
    id,
    ahuId,
    componentId,
    comment: "",
    fileId: null,
    conductedAt: new Date().toISOString(),
  };
}
